<template lang="pug">
  #CustomerReservationModel.CustomerModel.CustomerModel-reservationModel(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .row.align-items-start.mb-2.p-3
      .col-10.position-relative
        h2.mb-0 {{ title }}
        .bg-white.rounded-circle.border.border-black.overflow-hidden.d-flex.align-items-center.justify-content-center(
          style="width: 40px;height: 40px;position: absolute;right: 0;top: 0;",
          @click="openScheduleModalHandler()"
        )
          b-img(
            :src="iconUrl.IconClendart",
            fluid,
            width="25",
            height="25",
            alt="Icon"
          )
      .col-2
        img.rounded-circle.closeIcon(
          v-lazy="iconUrl.IconClose",
          fluid,
          alt="Close Icon",
          @click="closeModel()"
        )
    .content.customerInput
      ValidationObserver(
        ref="form"
        tag="form"
        @submit.stop.prevent="submitHandler"
      )
        b-form-group
          .itemRow.d-flex.align-items-center.justify-content-center
            p.mb-0 {{ user.store_name }}
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValService",
            v-slot="{ errors }"
          )
            multiselect(
              v-model="form.service",
              tag-placeholder="輸入搜尋預約服務",
              placeholder="請選擇預約服務",
              selectedLabel="已選擇",
              selectLabel="",
              :showLabels="false",
              label="reserve_type_name",
              track-by="reserve_type_id"
              :options="reservationsTypeList",
              :allow-empty="false",
              deselectLabel="",
              noOptions="無預約服務",
            )
              template(slot="noOptions")
                strong 無預約服務
            div(
              id="input-name-live-feedback",
              v-show="form.service === ''"
            )
              span(
                style="font-size: 80%;color: #dc3545;"
              ) 此欄不可為空
            .pt-2(
              v-if="form.service && form.service.reserve_type_name === '珠寶保養'"
            )
              small.d-block.m-1.text-left 珠寶保養事前須知:
              small.d-block.m-1.text-left 需視實際評估作品後，可能有部分收費需求或更長工作天進行後續服務。
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValDate"
          )
            b-form-datepicker.d-flex.align-items-center.justify-content-center(
              id="date",
              type="date",
              required,
              trim,
              :state="validState('date')",
              v-model="form.date",
              aria-describedby="input-live-help input-name-live-feedback",
              placeholder="請選擇預約日期",
              :min="dateMinLimit",
              @input="getReservationTimeHandler()"
            )
            b-form-invalid-feedback(
              id="input-name-live-feedback"
            )
              span 此欄不可為空
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValTimeId"
          )
            multiselect.padding-right-0(
              v-model="form.timeId",
              tag-placeholder="輸入搜尋預約時間",
              placeholder="請選擇預約時間",
              selectedLabel="已選擇",
              selectLabel="點擊新增預約時間",
              label="start_time",
              track-by="reserve_period_id",
              deselectLabel="",
              :custom-label="nameWithTimeId",
              :options="reservationTimeList",
              :allow-empty="false",
              noOptions="無預約時間",
              style="height: 45px;"
            )
              template(slot="noOptions")
                strong 無預約時間
        b-form-group
          .itemRow.d-flex.align-items-center.justify-content-center
            p.mb-0 {{ user.display_name }}
        b-form-group
          .itemRow.d-flex.align-items-center.justify-content-center
            p.mb-0 {{ user.mobile }}
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValJoinPeople",
            v-slot="{ errors }"
          )
            multiselect(
              v-model="form.joinPeople",
              tag-placeholder="輸入搜尋參與人數",
              placeholder="請選擇參與人數",
              selectedLabel="已選擇",
              selectLabel="",
              :showLabels="false",
              label="text",
              track-by="id"
              deselectLabel="",
              :options="joinPeopleOption",
              :allow-empty="false"
              noOptions="無參與人數"
            )
              template(slot="noOptions")
                strong 無參與人數
            div(
              id="input-name-live-feedback",
              v-show="form.joinPeople === ''"
            )
              span(
                style="font-size: 80%;color: #dc3545;"
              ) 此欄不可為空
    .row.no-gutters
      .col-12
        button.btn.btn-block.btn-primary.text-center.rounded-0(
          type="button",
          @click="submitHandler()"
        ) 儲存送出
</template>

<script>
// Icon
import IconClendartUrl from '@/assets/images/icon/icon_calendar.png';
import IconCloseUrl from '@/assets/images/icon/icon_close.png';
import { mapState } from 'vuex';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import $ from 'jquery';

const moment = require('moment');
const _ = require('lodash');

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

export default {
  name: 'ReservationModel',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    user: {
      type: [Object, null]
    },
    store_id: {
      type: [String, Number]
    }
  },
  data() {
    return {
      iconUrl: {
        IconClendart: IconClendartUrl,
        IconClose: IconCloseUrl
      },
      showModel: false,
      form: {
        service: null,
        date: null,
        timeId: null,
        joinPeople: null
      },
      dateMinLimit: moment().format(),
      windowScrollHeight: 0, // 視窗原本位置
      joinPeopleOption: [
        {
          id: 1, text: '1'
        },
        {
          id: 2, text: '2'
        },
        {
          id: 3, text: '3'
        },
        {
          id: 4, text: '4'
        },
        {
          id: 5, text: '5'
        },
        {
          id: 6, text: '6'
        },
        {
          id: 7, text: '7'
        },
        {
          id: 8, text: '8'
        }
      ]
    };
  },
  mounted() {
    this.$EventBus.$on('openReservationModel', () => {
      this.openModel();
    });
  },
  methods: {
    nameWithTimeId({ start_time, end_time, site }) {
      return `${start_time}~${end_time}(${site})`;
    },
    moment() {
      return moment();
    },
    getReservationTimeHandler() {
      const vm = this;
      if (vm.store_id && vm.form.date) {
        vm.$swal.fire({
          title: '請稍候，\n取得該店可預約時段中',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });
        vm.$store.dispatch('sa_reservation/getReservationTimeListHandler', {
          store_id: vm.store_id,
          reserve_date: vm.form.date
        })
          .then((data) => {
            if (data.options.length === 0) {
              vm.$swal.fire({
                icon: 'info',
                title: '請選擇其他預約日期、此日期無預約時段'
              }).then(() => {
                $('#date').click();
              });
            } else {
              vm.$swal.close();
            }
          });
      } else {
        vm.$store.commit('sa_reservation/resetReservationTimeListHandler');
        vm.form.timeId = null;
      }
    },
    initHandler() {
      const vm = this;
      vm.form = {
        service: null,
        date: null,
        timeId: null,
        joinPeople: null
      };
    },
    openModel() {
      this.initHandler();
      this.showModel = true;
    },
    closeModel() {
      this.$emit('closeModelHandler');
      this.initHandler();
      this.showModel = false;
    },
    // 檢查欄位
    validState(key) {
      const vm = this;
      // 其餘統一判斷
      if (vm.form[key] !== null) {
        return this.form[key] ? true : false;
      }
      return null;
    },
    // 送出表單
    async submitHandler() {
      const vm = this;
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        if (vm.form.service === null) {
          vm.form.service = '';
        }
        if (vm.form.date === null) {
          vm.form.date = '';
        }
        if (vm.form.timeId === null) {
          vm.form.timeId = '';
        }
        if (vm.form.joinPeople === null) {
          vm.form.joinPeople = '';
        }
        vm.$swal.fire({
          icon: 'error',
          title: '請填妥必填欄位或格式輸入錯誤'
        });
      } else {
//        const key = _.findKey(vm.reservationTimeList, (val) => val.id === vm.form.timeId.id);
const key = _.findKey(vm.reservationTimeList, (val) => val.reserve_period_id === vm.form.timeId.reserve_period_id);
              const now = moment().format('hh:mm');
              const beginTime = moment(vm.reservationTimeList[key].start_time, 'hh:mma');
              const endTime = moment(now, 'hh:mma');
              const today = moment().format('YYYY-MM-DD');
              const reservationDate = moment(vm.form.date).format('YYYY-MM-DD');

        if (moment(reservationDate).isBefore(today)) {
          vm.$swal.fire({
            icon: 'error',
            title: '預約時間不可小於目前日期'
          });
        } else if (vm.form.date === moment().format('YYYY-MM-DD') && beginTime.isBefore(endTime)) {
          vm.$swal.fire({
            icon: 'error',
            title: '預約時間不可小於目前時間'
          });
        } else {
          vm.$swal.fire({
            title: '請稍候，\n表單送出中',
            allowOutsideClick: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });

          const sendData = {
            store_id: vm.store_id,
            member_uuid: `${vm.user.member_uuid || vm.user.member_line_uuid}`,
            reservation_type_id: vm.form.service.reserve_type_id,
            reservation_period_id: vm.form.timeId.reserve_period_id,
            reservation_date: vm.form.date,
            companion_number: vm.form.joinPeople.id
          };

          vm.$store.dispatch('sa_chat/storeReservationHandler', sendData)
            .then(() => {
              vm.$swal.close();
              vm.closeModel();
            });
        }
      }
    },
    // 打開班表彈窗
    async openScheduleModalHandler() {
      const vm = this;
      if (!vm.store_id) return;
      vm.windowScrollHeight = $('html').scrollTop();
      await vm.scrollToTop();
      vm.$EventBus.$emit('openPersonnelScheduleModel', {
        store_id: vm.store_id
      });
    },
    // 把視窗移到最頂部
    scrollToTop() {
      return new Promise((resolve) => {
        if ($('CustomerReservationModel').scrollTop() === 0) {
          resolve();
        } else {
          $('CustomerReservationModel').animate({
            scrollTop: 0
          }, 500);
        }
        setTimeout(() => {
          // 鎖定上下滑動 防止爆版
          $('CustomerReservationModel').addClass('overflow-hidden');
          resolve();
        }, 550);
      });
    }
  },
  computed: {
    ...mapState({
      reservationsTypeList: (state) => state.sa_reservation.reservationsTypeList,
      reservationTimeList: (state) => state.sa_reservation.reservationTimeList
    })
  },
  beforeDestroy() {
    this.$EventBus.$off('openReservationModel');
  }
};
</script>

<style lang="scss" scoped>
.customerInput {
  * {
    text-align: center;
  }
  input,
  select,
  .b-form-btn-label-control,
  .itemRow {
    border-radius: 0;
    border: 0;
    border-top: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;
    background-color: #FCFBFB;
    text-align: center;
    text-align-last: center;
    height: 45px;
    padding-right: 0;
  }
}

.multiselect__tags {
  border: none!important;
  height: 100%;
  padding-right: 0;
}
</style>
